export default __webpack_public_path__ + "static/media/paperclip.e4f5aac8.svg";